import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/components/common/PageHeader";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { BookOpen, MessageSquare, LifeBuoy, Zap, ChevronRight } from "lucide-react";

// No help-center/CMS backend exists — these route to the actual in-app
// screen each topic covers, rather than a fake "article" that doesn't exist.
const TOPICS = [
  { icon: BookOpen, title: "Getting started", desc: "Learn the basics of the ARC Beacon command center.", to: "/dashboard" },
  { icon: Zap, title: "Live tracking", desc: "Monitor vehicles in real time on the live map.", to: "/map" },
  { icon: LifeBuoy, title: "Alerts & geofences", desc: "Set up boundaries and safety notifications.", to: "/geofences" },
  { icon: MessageSquare, title: "Reports & exports", desc: "Analyze fleet performance and export data.", to: "/reports" },
];

const SUPPORT_EMAIL = "support@arcbeacon.local";

export default function Help() {
  const navigate = useNavigate();
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  // There's no support-ticketing backend, so this opens the user's own
  // email client with the message prefilled — a real send, just not one
  // ARC Beacon's servers relay.
  const submit = (e) => {
    e.preventDefault();
    const body = encodeURIComponent(message);
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${body}`;
    toast.success("Opening your email client…");
  };

  return (
    <div className="p-4 md:p-6 lg:p-8">
      <PageHeader title="Help & Support" subtitle="Guides, documentation and direct support for your team." />
      <div className="grid gap-4 lg:grid-cols-[1fr_360px]">
        <div className="grid gap-3 sm:grid-cols-2">
          {TOPICS.map((t) => (
            <Card key={t.title} className="group cursor-pointer border-border/70 bg-card/50 p-5 transition hover:border-border hover:bg-card" onClick={() => navigate(t.to)}>
              <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-border/60 bg-secondary/40"><t.icon className="h-5 w-5" /></div>
              <h3 className="mt-3 flex items-center gap-1 font-medium">{t.title} <ChevronRight className="h-4 w-4 text-muted-foreground transition group-hover:translate-x-0.5" /></h3>
              <p className="mt-1 text-sm text-muted-foreground">{t.desc}</p>
            </Card>
          ))}
        </div>
        <Card className="border-border/70 bg-card/60 p-6">
          <h3 className="font-display text-lg font-medium">Contact support</h3>
          <p className="mt-1 text-sm text-muted-foreground">Opens your email client, addressed to {SUPPORT_EMAIL}.</p>
          <form className="mt-4 space-y-3" onSubmit={submit}>
            <Input placeholder="Subject" required value={subject} onChange={(e) => setSubject(e.target.value)} />
            <Textarea placeholder="How can we help?" rows={4} required value={message} onChange={(e) => setMessage(e.target.value)} />
            <Button type="submit" className="w-full" data-testid="support-submit">Send message</Button>
          </form>
        </Card>
      </div>
    </div>
  );
}
